import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// 1. Encontra a "porta de entrada" (a div com id="root") no nosso arquivo index.html.
const root = ReactDOM.createRoot(document.getElementById('root'));

// 2. Diz ao React para renderizar nosso componente principal <App /> dentro daquela porta.
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
